var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsCursorClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.646 9.709c-.335-.984.562-1.935 1.532-1.683l.104.032 7.175 2.393c.881.294 1.168 1.387.579 2.064l-.078.083-.65.65 1.081 1.081c.649.649.681 1.686.098 2.387l-.098.108-.995.995a1.776 1.776 0 0 1-2.383.09l-.105-.096-1.064-1.063-.66.656a1.306 1.306 0 0 1-2.102-.409l-.042-.11-2.392-7.178zm1.811.164 1.975 5.928.826-.819a.833.833 0 0 1 1.098-.067l.078.07 1.65 1.65c.026.025.071.031.107.018l.031-.019.982-.981a.114.114 0 0 0 .026-.114l-.02-.031-1.634-1.635-.039-.034a.833.833 0 0 1-.069-1.1l.07-.078.819-.82-5.9-1.968zM3.983 8.275a.833.833 0 0 1 .098 1.661l-.098.006h-1.9a.833.833 0 0 1-.097-1.661l.097-.006h1.9zm-.556-4.43c.3-.301.774-.324 1.1-.07l.079.07 1.35 1.35a.833.833 0 0 1-1.1 1.247l-.079-.07-1.35-1.35a.833.833 0 0 1 0-1.178zm1.317 8.032a.833.833 0 0 1 1.248 1.1l-.07.079-1.35 1.35a.833.833 0 0 1-1.247-1.1l.07-.079 1.35-1.35zm3.948-10.21c.427 0 .78.321.827.736l.006.097v1.9a.833.833 0 0 1-1.661.097L7.858 4.4V2.5c0-.46.373-.833.834-.833zM12.81 3.81a.833.833 0 0 1 1.248 1.1l-.07.078-1.35 1.35a.833.833 0 0 1-1.248-1.1l.07-.078 1.35-1.35z",
    fill: "#1B3DF2",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCursorClick);
export default __webpack_public_path__ + "static/media/icons-cursor-click.8d36fd7948fcdef30144e9662759d0fb.svg";
export { ForwardRef as ReactComponent };